/**
 * MSW (Mock Service Worker) Browser Setup
 *
 * Initialize MSW for browser mocking in development
 */

import { setupWorker } from 'msw/browser';
import { handlers } from './mock-handlers';

// Export the worker instance
export const worker = setupWorker(...handlers);

// Start the worker in development mode
export async function initMocks() {
  // Only start in browser and when mocks are enabled
  if (
    typeof window !== 'undefined' &&
    import.meta.env.VITE_ENABLE_MOCKS === 'true'
  ) {
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        url: '/mockServiceWorker.js',
      },
    });
    console.log('[MSW] Mock worker started');
  }
}
